import { Spinner } from '@cycle-app/ui';
import { CommentChatIcon } from '@cycle-app/ui/icons';

import { useProductAddOn } from 'src/hooks';
import { useMeetingsIntegration } from 'src/hooks/integration/useMeetingsIntegration';

import classes from './HomeViewMeetings.module.css';
import { Container, Title } from './HomeViewMeetings.styles';
import { HomeViewMeetingsEmpty } from './HomeViewMeetingsEmpty';
import { HomeViewMeetingsEnabled } from './HomeViewMeetingsEnabled';

const title = (
  <Title>
    <CommentChatIcon />
    My meetings
  </Title>
);

export const HomeViewMeetings = () => {
  const {
    isInstalled, isLoading,
  } = useMeetingsIntegration();
  const meetingsAddon = useProductAddOn('MEETINGS');

  if (isLoading || meetingsAddon.isLoading) {
    return (
      <Container>
        {title}
        <Spinner />
      </Container>
    );
  }

  return (
    <Container
      className={classes.container}
    >
      {title}
      {meetingsAddon.isEnabled && isInstalled
        ? <HomeViewMeetingsEnabled />
        : <HomeViewMeetingsEmpty />}
    </Container>
  );
};
